// Build an embeddable iframe URL from a YouTube/Vimeo/Loom share link.
// Returns null for unrecognized hosts so callers fall back to a plain link.
export function toEmbedUrl(url: string | undefined | null): string | null {
  if (!url) return null;
  const u = url.trim();
  if (!u) return null;
  const lower = u.toLowerCase();
  if (lower.includes('/embed/') || lower.includes('player.vimeo.com/video/')) return u;

  const yt = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/i);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  const vimeo = u.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  const loom = u.match(/loom\.com\/share\/([\w-]+)/i);
  if (loom) return `https://www.loom.com/embed/${loom[1]}`;

  return null;
}
